import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: [],
  discountCodesFetched: false,
  loading: false,
  error: false,
  errorMessage: '',
};

const promoCodesSlice = createSlice({
  name: 'promocodes',
  initialState,
  reducers: {
    setLoading(state, action) {
      const { isLoading, willClearError } = action.payload;

      if (willClearError) {
        state.error = false;
        state.errorMessage = '';
      }
      state.loading = isLoading;
    },
    setError(state, action) {
      state.loading = false;
      state.error = true;
      state.errorMessage = action.payload;
    },
    setDiscountCodes(state, action) {
      state.list = action.payload;
      state.discountCodesFetched = true;
      state.error = false;
      state.errorMessage = '';
      state.loading = false;
    },
   
    resetDiscountCodes: (state) => initialState,
    logout: (state) => initialState,
  },
});

export const promoCodesActions = promoCodesSlice.actions;
export default promoCodesSlice;
